import { c as _c } from "react/compiler-runtime";
import { Spinner } from "@/components/Spinner/Spinner.component";
export function PaywallLoadingSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex h-[1435px] flex-col space-y-5 border-smoke border-t border-solid pt-5 text-center md:h-[1325px] lg:h-[755px]"><div className="flex justify-center py-8"><Spinner className="h-12 w-12 fill-primary text-smoke" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}